const readMoreButtons = document.querySelectorAll('#readSpecialOffer');

readMoreButtons.forEach(button => {
  button.addEventListener('click', function () {
    const parentSection = this.closest('.desc_section');

    if (parentSection.classList.contains('desc_section_active')) {
      parentSection.classList.remove('desc_section_active');
      this.textContent = 'Läs mer +';
    } else {
      parentSection.classList.add('desc_section_active');
      this.textContent = 'Visa mindre -';
    }
    scroll_function('#CollapsibleAccordion_description_tab');
  });
});


let headerHeight = $('.shopify-section-group-header-group').outerHeight();
function scroll_function(href) {
  $('html, body').animate({
    scrollTop: $(href).offset().top - ((headerHeight) + 200) + 'px'
  }, 500);
}